// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*@import '../styles/vuetify-dark';*/\n.dsgvo[data-v-249db64c] {\n  color: black;\n}\n.dsgvo *[data-v-249db64c] {\n  color: black;\n}\n.dsgvo[data-v-249db64c] .v-input--selection-controls {\n  padding-top: 0;\n  margin-top: 0;\n}", ""]);
// Exports
module.exports = exports;
